import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "party"
const PartyIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M7.102 20.272 2.92 22.064a.75.75 0 0 1-.987-.978l1.76-4.223zM11.565 18.36l-3.35 1.434L4.16 15.74l1.407-3.377zM9.334 6.787c.491.036 1.024.205 1.554.45q.205.096.417.21c-.186.39-.293.78-.357 1.118a6 6 0 0 0-.056.372 7 7 0 0 0-.636-.34c-.436-.201-.784-.296-1.03-.314a.7.7 0 0 0-.237.015.2.2 0 0 0-.036.014q-.005.001-.005.002l-.005.007a.2.2 0 0 0-.014.036.7.7 0 0 0-.014.237c.018.246.112.595.315 1.03.402.868 1.16 1.933 2.193 2.966s2.099 1.79 2.966 2.193c.436.203.785.298 1.03.315a.7.7 0 0 0 .237-.014q.03-.009.036-.014.003 0 .005-.003l.002-.002.003-.004.013-.036a.7.7 0 0 0 .015-.238c-.017-.246-.113-.594-.315-1.03a8.3 8.3 0 0 0-.75-1.264c.707.619 1.502 1.106 2.374 1.323l.008.001c.095.295.16.585.18.862.034.49-.06 1.04-.469 1.448-.307.307-.693.436-1.074.467l-3.006 1.288-6.643-6.642 1.523-3.654.042-.084a.75.75 0 0 1 .363-.32c.4-.347.912-.428 1.37-.395M22.606 15.549l-.961 1.152-2.25-1.875.96-1.152z" />
          <path
            fillRule="evenodd"
            d="M17.79 2.598c1.263 0 2.404.751 3.152 1.377a10 10 0 0 1 1.196 1.19l.072.087q.013.016.02.026l.007.007.001.002v.002l-.589.463-.59.463-.002-.003-.012-.014-.054-.066a8.617 8.617 0 0 0-1.012-1.007c-.689-.576-1.479-1.027-2.19-1.027-.782 0-1.256.264-1.595.625-.367.39-.617.934-.84 1.565q.17-.015.341-.02c1.005-.016 2.082.303 2.859 1.08.68.68 1.197 1.53 1.428 2.34.218.763.244 1.767-.503 2.395-.598.503-1.348.65-2.124.458-.745-.184-1.491-.673-2.21-1.392a5.04 5.04 0 0 1-1.337-2.408q-.057.145-.095.343c-.062.329-.067.711-.038 1.093a8 8 0 0 0 .21 1.291l.02.079.005.018.001.003-.721.205-.722.204v-.001l-.001-.003-.003-.009-.007-.03q-.011-.037-.027-.102a9.477 9.477 0 0 1-.25-1.542 5.8 5.8 0 0 1 .059-1.483c.094-.498.293-1.041.711-1.46a3.4 3.4 0 0 1 .754-.563c.045-.347.123-.678.23-.981.238-.674.573-1.477 1.168-2.109.625-.664 1.495-1.096 2.687-1.096m-2.069 5.17a3 3 0 0 0-.546.06c.071.79.386 1.615 1.03 2.26.611.61 1.127.902 1.511.997.353.088.6.016.798-.15.05-.043.192-.253.025-.835-.152-.535-.522-1.167-1.046-1.691-.427-.428-1.078-.653-1.772-.64"
            clipRule="evenodd"
          />
          <path d="m23.261 8.518-1.875 1.125-.772-1.286 1.875-1.125zM11.994 5.157l-1.488.186-.375-3 1.488-.186z" />
        </svg>
      }
    </span>
  )
}
export default PartyIcon
